import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  useAuth0ExchangeTokenQuery,
  useLazyGetUserInfoQuery,
} from '../apis/auth/auth.api.ts'
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query'
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../utils/local-storage.ts'
import {
  requestUserInfo,
  setAccessToken,
  setUserInfo,
} from '../features/user/user.slice.ts'

export const IpponLoginPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [getUserInfo, userInfoResult] = useLazyGetUserInfoQuery()
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0()
  const [userToken, setUserToken] = useState<string | null>(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isAuthenticated) {
      getAccessTokenSilently()
        .then((res) => setUserToken(res))
        .catch((err) => console.error(err))
    }
  }, [isAuthenticated, getAccessTokenSilently])

  const {
    data: exchangeTokenData,
    isFetching,
    isSuccess,
    isError,
    error,
  } = useAuth0ExchangeTokenQuery(userToken ? userToken : skipToken)
  console.log(exchangeTokenData?.data)

  useEffect(
    () => {
      if (!isFetching && exchangeTokenData) {
        console.log('reached here')
        if (exchangeTokenData && exchangeTokenData.data.accessToken) {
          setLocalStorageItem('accessToken', exchangeTokenData.data.accessToken)
          dispatch(setAccessToken(exchangeTokenData.data.accessToken))
          dispatch(requestUserInfo())
          getUserInfo()
        }
      }
    },
    //[dispatch, getUserInfo, exchangeTokenData, isFetching])
    [exchangeTokenData, isFetching]
  )

  useEffect(() => {
    if (isSuccess && userInfoResult.isSuccess) {
      dispatch(setUserInfo(userInfoResult.data.data))
      const disclaimerAccepted = getLocalStorageItem('disclaimerAccepted')
      // If role is null, then they are an internal user
      // Internal contributors do not see disclaimer page
      if (!disclaimerAccepted && userInfoResult.data.data.role === '') {
        if (userInfoResult.data.data.region === 'Global') {
          navigate('/login/global-disclaimer', {
            state: { from: location.pathname },
          })
        } else {
          navigate('/login/disclaimer', {
            state: { from: location.pathname },
          })
          return
        }
      } else {
        navigate(location.state?.from || '/idea')
      }
    } else if (isError) {
      const errorResponse = error as FetchBaseQueryError
      if ('status' in errorResponse && errorResponse.status === 403) {
        navigate('/inactive')
      } else {
        navigate('/logout')
      }
    }
  }, [
    isSuccess,
    userInfoResult.isSuccess,
    navigate,
    location.state?.from,
    dispatch,
    location.pathname,
    isError,
    error,
  ])

  if (isLoading) {
    return <div>Loading ...</div>
  }

  return isAuthenticated && <div>Authenticated</div>
}
